import { useState } from "react";
import SVG, { SVGSizes } from "../core/SVG";
import { InputProps } from "./Input";

export type IconInputProps = InputProps & {
    svg?: string;
    svgSize?: SVGSizes;
    svgColor?: string;
};

const PasswordInput = ({
    value,
    handleChange,
    label,
    placeHolder,
    loading = false,
    rounded = false,
    disabled = false,
    error,
    svg = "lock",
    svgSize = 16,
    svgColor,
    className,
    style
}: IconInputProps) => {
    const [showPswd, setShowPswd] = useState(false);
    const handleShowPswd = () => setShowPswd(() => !showPswd);
    return (
        <div className={`field ${className}`} style={style}>
            {label ? <label>{label}</label> : ""}

            <div className={`control has-icon ${loading ? "is-loading" : ""}`}>
                <input
                    type={showPswd ? "text" : "password"}
                    className={`input password-input ${rounded ? "is-rounded" : ""}`}
                    onChange={(e) => handleChange(e)}
                    value={value}
                    placeholder={placeHolder || "●●●●●●●"}
                    disabled={disabled}
                />
                <div className="form-icon">
                    <SVG
                        svg={svg}
                        size={svgSize}
                        className={`${svgColor || "light-grey-svg"} cursor-default`}
                    />
                </div>
                <div className="show-icon">
                    <div onClick={handleShowPswd}>
                        <SVG
                            svg={showPswd ? "show-pswd" : "hide-pswd"}
                            size={18}
                            className={`${svgColor || "light-grey-svg"}`}
                        />
                    </div>

                    {/* <div
                        className="momeento-svg hide-pswd-svg"
                    ></div> */}
                </div>
            </div>
            <p className={`field-error ${error ? "" : "is-hidden"}`}>{error}</p>
        </div>
    );
};
export default PasswordInput;
